import React, { memo } from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from '@finect/tabular-core/Button';
import arrow from './arrow.svg';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(0);
  }

  40% {
    transform: translateX(-14px);
  }

  60% {
    transform: translateX(-7px);
  }
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const CoverNavContainer = styled(Button)`
  position: relative;
  max-width: fit-content;
  padding: 18px 140px 18px 30px;
  margin-top: 48px;
  background: ${({ theme }) => theme.coverButtonBackgroundColor || theme.mainColor};
  vertical-align: bottom;
  font-size: 1.2em;
  color: #fff;
  text-decoration: none;
  transition: background-color 0.2s ease;

  border-radius: 4px;

  &:focus,
  &:active {
    box-shadow: 0 0 8px
      ${({ theme, secondary }) => (secondary ? theme.secondaryButtonFocusShadowColor : theme.buttonFocusShadowColor)};
  }

  &:after {
    position: absolute;
    z-index: 1;
    top: 50%;
    right: 0;
    width: 90px;
    height: 18px;
    margin-top: -11px;
    content: '';
    background: url(${arrow}) no-repeat right center;
    background-size: 90px auto;
    animation: ${bounce} 2s infinite cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

const CoverNavContent = styled.span`
  position: relative;
  z-index: 2;
`;

const ButtonStart = ({ onClick, children }) => (
  <Inner>
    <CoverNavContainer onClick={onClick}>
      <CoverNavContent>{children}</CoverNavContent>
    </CoverNavContainer>
  </Inner>
);

ButtonStart.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string
};

export default memo(ButtonStart);
